import React,{useContext} from 'react'
import {FaMapMarkerAlt, FaBusinessTime} from "react-icons/fa";
import RootContext from '../../context/RootContext';
import OpenNewTab from '../../hooks/OpenNewTab'
import './Footer.css'

const Footer = () => {
  const {year} = useContext(RootContext)
  const {openInNewTab} = OpenNewTab();
  return (
    <div className="footer-container text-white py-4">
            <div className="row px-2">
        <div className="col-lg-3 px-3">
            <h5 className="py-3">Portfolio</h5>
            <p className='text-justify'>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters,</p>
        </div>
        <div className="col-lg-3 px-3">
          <h5 className="py-3">Product</h5>
          <p>product 1</p>
          <p>product 2</p>
          <p>product 1</p>
          <p>product 1</p>
        </div>
        <div className="col-lg-3 px-3">
          <h5 className="py-3">Services</h5>
          <p>Services 1</p>
          <p>Services 2</p>
          <p>Services 1</p>
          <p>Services 1</p>
        </div>
        <div className="col-lg-3 px-3">
          <h5 className="py-3">Our Office</h5>
          <p><i className='me-3'> <FaMapMarkerAlt/></i>Mirpur, Dhaka, Bangladesh</p>
          <p><i className='me-3'><FaBusinessTime/></i>Sunday to Thursday 8.00 am- 5.00 pm</p>
        </div>
      </div>
      <hr/>
      <div className="text-center px-1">
        <small>Copyright &copy; {year} All rights reserved | This website is made by <span className='text-primary cursor-pointer text-decoration-underline' onClick={(e) => openInNewTab("https://miltonhossain.netlify.app")}>Md. Milton Hossain</span></small>
      </div>
    </div>
  )
}

export default Footer